<template>
  <div class="col backgroundForm">
  
  <div class="form-row" >
    <div class="col-12 col-md-4 offset-md-4">
      <div class="form-group">
        <label for="capitanias">Unidad</label>
        <select name="captain" id="captain" class="form-control" v-model="captain_select">
          <option value="0">TODAS LAS UNIDADES</option>
          <option v-for="p in ports" :key="p.id" :value="p.id">{{p.long_detail }} {{p.name_port }}</option>
        </select>
      </div>
    </div>
    <div class="col-12" align="center">
        <button class="btn btn-info" @click="mViewMap"><font-awesome-icon icon="eye" /> Ver Mapa</button>
    </div>                        
  </div>

  
    <CargarMapa v-if="renderComponent"
      :configMapa="configMapa"
      apiKey="AIzaSyDQ4Ii0YR8i1LCRjgK9rfoDxVvE2S9__tU"
    >

      <template slot-scope="{ google, map }">
        <Marcadores
          v-for="marker in cLocationCaptains"
          :key="marker.id"
          :marker=marker
          :google="google"
          :map="map"
        />
      </template>

    </CargarMapa>

  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  const qs= require('qs');

  import modalLoading from '../modal/modalLoading';

  import CargarMapa from "./LoadMap";
  import Marcadores from "./MarksMaps";
  

  import { configMapa } from "@/constants/configMapaRead";
  import MarksMapsVue from './MarksMaps.vue';

  import capitania_menor from '@/assets/images/capitania_menor.png'
  import capitania_mayor from '@/assets/images/capitania_mayor.jpg'
  import base_naval from '@/assets/images/base_naval.jpg'
  import pma from '@/assets/images/pma.jpg'
  import oscar from '@/assets/images/oscar.png'
  

  export default {
    components: {
      CargarMapa,
      Marcadores
    },
    mounted(){
      this.callCaptains();
    },
    data() {
      return {
        showMap:false,
        send_dispatch:true,
        renderComponent:false,
        ports:[],
        captain_select:-1,
        juris:[]
      };
    },
    methods:{

      mViewMap(){
        this.showMap=true;
        this.mGenerateMark();
        this.forceRerender();        
      },
      mConvertRadial(coord=-1){
                
        let coordenada_aux=coord<0 ? coord * -1: 0;

        let entero=0;
        let minuto=0;
        let minuto_aux=0;
        let segundo=0;

        let coordenada_end=null;

        entero=Math.trunc(coordenada_aux);
        minuto_aux=coordenada_aux-entero;
        minuto=Math.trunc(minuto_aux*60);

        segundo=Math.trunc((minuto-minuto_aux)*60);

        coordenada_end=`${entero}° ${minuto}' ${segundo}''`;
        return coordenada_end;

      },
      forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;

            // also use nextTick this way
            this.$nextTick().then(() => {
                // Add the component back in
                this.renderComponent = true;
            });
      },
      async callCaptains(){
        
        let cp=await axios.get(`getPortsComplete?api_token=${Vue.auth.getToken()}`);
        let cpj=await axios.get(`getJurisdiccion?api_token=${Vue.auth.getToken()}`);
        // console.log(cp);

        let juris_aux=cpj.data;

        this.ports=cp.data;
        this.juris=cpj.data;
         
      },
      mCallIcono(short_distrit, category){
        let ic_aux;
              switch(category){
                case 'CAPITANIA DE PUERTO MAYOR':
                  ic_aux=capitania_mayor;
                break;
                
                case 'CAPITANIA DE PUERTO MENOR':
                  ic_aux=capitania_menor;
                break;

                default:
                  ic_aux=oscar;
                break;
              }
        return ic_aux;
      },
      mGenerateMark(){
        this.$store.dispatch('sGoogleMaps/deleteMarkersCaptains', true);
        let marksCaptain=[];
        console.log(this.captain_select)
        if(this.captain_select > -1 ){
          // console.log(cp.data);
          // armar los datos y enviarlo al storage          
          
          if(this.captain_select === '0'){
            
            this.ports.forEach((cap, index) => {                      
              let ic_aux=this.mCallIcono(cap.short_distrit, cap.category_port);
              let w_aux=cap.category_port==='CAPITANIA DE PUERTO MAYOR' ? 40:40;
              let h_aux=cap.category_port==='CAPITANIA DE PUERTO MAYOR' ? 30:40;
              
              let lat=this.mConvertRadial(cap.latitud);
              let lon=this.mConvertRadial(cap.longitud);

              let location={
                id:index,
                position:{lat:parseFloat(cap.latitud), lng:parseFloat(cap.longitud)},
                icon:ic_aux,
                size:{width:w_aux, height:h_aux},
                title:`${cap.category_port} ${cap.name_port}`,
                description:`<div id="content" class="card">
                              <div class="card-body">
                                <h6 class="card-title">${cap.category_port} ${cap.name_port}</h6>
                                <p class="card-text"><b>Distrito:</b> ${cap.distrito}</p>
                                <p class="card-text"><b>Departamento:</b> ${cap.departament}</p>
                                <p class="card-text"><b>Latitud:</b> ${lat}  <b>Longitud:</b> ${lon}</p>
                              </div>
                            </div>`,
                jurisdiccion:[]
              }
              marksCaptain.push(location);

              this.juris.forEach( (cpp,index) =>{
                  let caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHJKMNPQRTUVWXYZ2346789";
                  let code=caracteres.charAt(Math.floor(Math.random()*caracteres.length)) + caracteres.charAt(Math.floor(Math.random()*caracteres.length))+index;
                  if(cpp.id_capitania===cap.id){
                    // let aux={lat:parseFloat(cpp.latitud), lng:parseFloat(cpp.longitud)}
                    // location.jurisdiccion.push(aux);
                    let lat=this.mConvertRadial(cpp.latitud);
                    let lon=this.mConvertRadial(cpp.longitud);

                    let location={
                    id:code,
                    position:{lat:parseFloat(cpp.latitud), lng:parseFloat(cpp.longitud)},
                    icon:oscar,
                    size:{width:20, height:32},
                    title:`${cap.category_port} ${cap.name_port}`,
                    description:`<div id="content" class="card">
                                  <div class="card-body">
                                    <h6 class="card-title">${cap.category_port} ${cap.name_port}</h6>
                                    <p class="card-text"><b>Referencia:</b> ${cpp.localidad}</p>
                                    <p class="card-text"><b>Departamento:</b> ${cpp.descripcion}</p>
                                    <p class="card-text"><b>Latitud:</b> ${lat}  <b>Longitud:</b> ${lon}</p>
                                  </div>
                                </div>`,
                    jurisdiccion:[]
                  }
                  marksCaptain.push(location);
                }
              })
              // location.jurisdiccion.push({lat:parseFloat(cap.latitud), lng:parseFloat(cap.longitud)});
              
            });
          }else{
            // console.log(this.ports)
            let icap=this.ports.findIndex(cpb => cpb.id === this.captain_select);
            // console.log(icap);
            // console.log(this.ports[icap]);
            let ic_aux=this.mCallIcono(this.ports[icap].short_distrit, this.ports[icap].category_port);
              let w_aux=this.ports[icap].category_port==='CAPITANIA DE PUERTO MAYOR' ? 40:40;
              let h_aux=this.ports[icap].category_port==='CAPITANIA DE PUERTO MAYOR' ? 30:40;
              
              let lat=this.mConvertRadial(this.ports[icap].latitud);
              let lon=this.mConvertRadial(this.ports[icap].longitud);

              let location={
                id:0,
                position:{lat:parseFloat(this.ports[icap].latitud), lng:parseFloat(this.ports[icap].longitud)},
                icon:ic_aux,
                size:{width:w_aux, height:h_aux},
                title:`${this.ports[icap].category_port} ${this.ports[icap].name_port}`,
                description:`<div id="content" class="card">
                              <div class="card-body">
                                <h6 class="card-title">${this.ports[icap].category_port} ${this.ports[icap].name_port}</h6>
                                <p class="card-text"><b>Distrito:</b> ${this.ports[icap].distrito}</p>
                                <p class="card-text"><b>Departamento:</b> ${this.ports[icap].departament}</p>
                                <p class="card-text"><b>Latitud:</b> ${lat}  <b>Longitud:</b> ${lon}</p>
                              </div>
                            </div>`,
                jurisdiccion:[]
              }
              marksCaptain.push(location);
              this.juris.forEach( (cpp, index)=>{
                if(cpp.id_capitania===this.ports[icap].id){
                  // let aux={lat:parseFloat(cpp.latitud), lng:parseFloat(cpp.longitud)}
                  // location.jurisdiccion.push(aux);
                  let lat=this.mConvertRadial(cpp.latitud);
                    let lon=this.mConvertRadial(cpp.longitud);

                    let location={
                    id:index,
                    position:{lat:parseFloat(cpp.latitud), lng:parseFloat(cpp.longitud)},
                    icon:oscar,
                    size:{width:20, height:32},
                    title:`${this.ports[icap].category_port} ${this.ports[icap].name_port}`,
                    description:`<div id="content" class="card">
                                  <div class="card-body">
                                    <h6 class="card-title">${this.ports[icap].category_port} ${this.ports[icap].name_port}</h6>
                                    <p class="card-text"><b>Referencia:</b> ${cpp.localidad}</p>
                                    <p class="card-text"><b>Descripcion:</b> ${cpp.descripcion}</p>
                                    <p class="card-text"><b>Latitud:</b> ${lat}  <b>Longitud:</b> ${lon}</p>
                                  </div>
                                </div>`,
                    jurisdiccion:[]
                  }
                  marksCaptain.push(location);
                }
              })
              // location.jurisdiccion.push({lat:parseFloat(this.ports[icap].latitud), lng:parseFloat(this.ports[icap].longitud)});
              
          }
          this.$store.dispatch('sGoogleMaps/addMarkersCaptains', marksCaptain);
        }else{

        }
      }
    },
    computed: {
      configMapa() {
        return {
          ...configMapa,
          center: this.mapCenter
        };
      }, 
      cDtsUser(){
        return this.$store.getters.getUserState;
      },     
      cLocationCaptains(){
        // return this.$store.getters.getLocation;
        // console.log(this.$store.getters['sGoogleMaps/getLocation'].lat);
        return this.$store.getters['sGoogleMaps/getMarkersCaptain'];
      },
      mapCenter() {
        // return this.markers[0].position;
        return this.cLocationCaptains[0].position;
      },
    }
  };
  
</script>


// WEBPACK FOOTER //
// src/components/maps/MapsCaptainViewJuris.vue